import React, { useRef } from "react";

import AdvisorsPicker from "../enrollment/advisorsPicker";
import { AdvisorSelection } from "../../models/EnrollmentHistoryDTO";
import { conReparto, esParejo, repartoParejo } from "../../utils/repartoParejo";

/*
	Asesoras de una promo: el picker (yo al 100 % por omisión) y el % de cada una ya repartido parejo. Los % se pueden corregir a mano;
	«Reparto Parejo» vuelve a partes iguales. Lo usan el panel de Caja y la Solicitud de Promoción (ESPEC_SOLICITUD_PROMO front 1).
*/

interface Props {
	campusId: number;
	value: AdvisorSelection[] | null;
	onChange: (list: AdvisorSelection[] | null) => void;
	disabled?: boolean;
	movil?: boolean;
	/** Yo al 100 % por omisión (asesora del plantel en sesión). */
	defaultSelf?: boolean;
	invalid?: boolean;
}

const AsesorasConReparto: React.FC<Props> = ({ campusId, value, onChange, disabled, movil, defaultSelf = true, invalid }) => {
	/** Alguien escribió un % a mano: desde entonces los cambios de lista no reparten solos. */
	const touched = useRef<boolean>(false);
	const cambiarLista = (list: AdvisorSelection[] | null) => {
		if (list === null || list.length < 1) { touched.current = false; onChange(list); return; }
		onChange(conReparto(list, touched.current));
	};
	const cambiarPct = (userId: string, v: string) => {
		if (!value) return;
		touched.current = true;
		onChange(value.map((x) => x.userId === userId ? { ...x, sharePercentage: v === "" ? null : Number(v) } : x));
	};
	const parejo = () => { if (!value) return; touched.current = false; onChange(repartoParejo(value)); };
	return (
		<div style={{ maxWidth: 520 }}>
			<AdvisorsPicker campusId={campusId} value={value} onChange={cambiarLista} disabled={disabled} defaultSelf={defaultSelf} invalid={invalid} />
			{value && value.length > 0 ? (
				<>
					<div style={{ display: "grid", gridTemplateColumns: movil ? "1fr" : "repeat(auto-fit, minmax(200px, 1fr))", gap: 6, marginTop: 6 }}>
						{value.map((a) => (
							<label key={"sh" + a.userId} style={{ position: "static", display: "flex", gap: 6, alignItems: "center", margin: 0, whiteSpace: "normal", overflow: "visible" }}>
								<span style={{ flex: 1, minWidth: 0, overflowWrap: "anywhere" }}>{a.name}</span>
								<input className="form-control form-control-sm" type="number" min="0" max="100" step="0.01" style={{ width: 84, textAlign: "right", fontSize: 16 }} placeholder="%"
									disabled={disabled} value={a.sharePercentage === null || a.sharePercentage === undefined ? "" : String(a.sharePercentage)}
									onChange={(e) => cambiarPct(a.userId, e.target.value)} />
							</label>
						))}
					</div>
					{value.length > 1 && !esParejo(value) ? (
						<button type="button" className="btn btn-link btn-sm p-0" style={{ marginTop: 4 }} disabled={disabled} onClick={parejo}>Reparto Parejo</button>
					) : null}
				</>
			) : null}
		</div>
	);
};

export default AsesorasConReparto;
